import { getRequest, postRequest, patchRequest, deleteRequest } from '../../services/apiService';
import { getProjectVerificationsAction, getProjectVerificationsCountAction, getProjectVerificationAction } from '../reducers/ProjectVerificationReducer';

const route_path = 'projectverification'

export const getAllProjectVerifications = ({ page, limit, search, status, columnName }) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/list`, { page, limit, search, status, columnName });
    dispatch(getProjectVerificationsAction(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getAllProjectVerificationCount = ({ page, limit, search, status }) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/count`, { page, limit, search, status });
    dispatch(getProjectVerificationsCountAction(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getProjectVerificationsById = (projectVerificationsId) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/${projectVerificationsId}`);
    dispatch(getProjectVerificationAction(response));
  } catch (error) {
    console.error(`Error fetching projectVerifications with ID ${projectVerificationsId}:`, error);
    throw error;
  }
};

export const createProjectVerifications = (projectVerificationsData) => async (dispatch) => {
  try {
    const response = await postRequest(`${route_path}/add`, projectVerificationsData);
  } catch (error) {
    console.error("Error creating projectVerifications:", error);
    throw error;
  }
};

export const updateProjectVerifications = (projectVerificationsId, projectVerificationsData) => async (dispatch) => {
  try {
    const response = await patchRequest(`${route_path}/edit/${projectVerificationsId}`, projectVerificationsData);
  } catch (error) {
    console.error(`Error updating projectVerifications with ID ${projectVerificationsId}:`, error);
    throw error;
  }
};

export const deleteProjectVerifications = (projectVerificationsId) => async (dispatch) => {
  try {
    const response = await deleteRequest(`${route_path}/delete/${projectVerificationsId}`);
  } catch (error) {
    console.error(`Error deleting projectVerifications with ID ${projectVerificationsId}:`, error);
    throw error;
  }
};

export const addProjectVerificationsData = () => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/add/requireddata`)
  } catch (error) {
    console.error("Error while getting add projectVerifications data:", error);
    throw error;
  }
}
